// Shared CSV export helper — Round 95e (Jun 2026).
//
// Every user-facing CSV the app produces goes through `downloadCsv`,
// which appends the DiviDrip generator footer (mirroring the stamp the
// PDFs and printouts already carry). Tax pros see these files — the
// footer is the referral surface.
//
// Footer rows are harmless on re-import: the CSV importer marks any
// row without a valid ticker + positive share count as "invalid" and
// skips it (exactly like the existing TOTAL / Stock Value rows).

export function csvEscape(v) {
  const s = v == null ? '' : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function brandFooterRows() {
  return [
    [],
    ['Generated by DiviDrip — Free Dividend Stock & ETF Portfolio Tracker'],
    ['https://twylightcrow.com', `Exported ${new Date().toLocaleDateString()}`],
  ];
}

export function downloadCsv(filename, rows) {
  const allRows = [...rows, ...brandFooterRows()];
  const csv = allRows.map((r) => r.map(csvEscape).join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  // Chrome requires the anchor to be in the DOM before .click() registers.
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Defer revokeObjectURL: revoking synchronously in the same microtask
  // as .click() cancels the download in current Chrome/Edge.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
